import { SvgIcon, SvgIconProps } from '@mui/material'

export function Eye(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 12.933c0-.037.018-.174.133-.426.11-.24.283-.533.525-.862.484-.66 1.198-1.405 2.074-2.107C7.504 8.12 9.789 7 12.005 7c2.219 0 4.503 1.105 6.27 2.514.874.697 1.584 1.44 2.067 2.1.518.709.658 1.165.658 1.319 0 .129-.12.524-.628 1.143-.473.576-1.176 1.213-2.05 1.809-1.757 1.197-4.06 2.127-6.312 2.115-2.255-.012-4.565-.96-6.328-2.16-.876-.598-1.582-1.235-2.056-1.805C3.11 13.417 3 13.037 3 12.933ZM12.005 5c-2.84 0-5.557 1.402-7.523 2.977-.993.795-1.834 1.664-2.435 2.483-.301.409-.554.82-.734 1.218-.176.385-.313.819-.313 1.255 0 .842.512 1.69 1.088 2.382.617.74 1.47 1.497 2.468 2.177C6.54 18.844 9.233 19.985 11.999 20c2.77.014 5.465-1.11 7.45-2.463.997-.68 1.852-1.441 2.468-2.19.58-.707 1.083-1.563 1.083-2.414 0-.826-.478-1.726-1.044-2.5-.602-.823-1.442-1.692-2.435-2.483C17.554 6.382 14.841 5 12.005 5ZM12 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.5-3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default Eye
